// Date/date of birth field
const INVALID_DAY = 'This is a required field, please fill in the day in DD format.';
const INVALID_DAY_LENGTH = 'The day must have a length of 2 numbers.';
const INVALID_DAY_FORMAT = 'The day must be from 1 - 31, only numbers are allowed.';
const INVALID_MONTH = 'This is a required field, please fill in the day in MM format.';
const INVALID_MONTH_LENGTH = 'The month must have a length of 2 numbers.';
const INVALID_MONTH_FORMAT = 'The month must be from 1 - 12, only numbers are allowed.';
const INVALID_YEAR = 'This is a required field, please fill in the day in YYYY format.';
const INVALID_YEAR_LENGTH = 'The year must have a length of 4 numbers.';
const INVALID_YEAR_FORMAT = 'The year can only have numbers, no spaces or special characters are allowed.';
const EMPTY_DATE = 'Please enter the date in DD/MM/YYYY format';
const INVALID_DATE_INPUT_FORMAT = 'The date format should be DD/MM/YYYY. Only numbers are allowed.';
const INVALID_FUTURE_DATE = 'The date must be in the past.';
const INVALID_PAST_DATE = 'The date must be in the future.';
const EMPTY_CHECKBOX = 'Please select an option';

// Numeric text field
const INVALID_NUMERIC_FORMAT = 'Please complete this field';

const INVALID_YESNO_FORMAT = 'Please select an option';
// Name fields
const INVALID_NAME_FORMAT = 'Please do not use any numbers or special characters.';
const INVALID_NAME_FORMAT_NEW = "Only the following characters are allowed: letters, numbers, spaces, and the following special characters: -'.";

// Mobil fields step4
const INVALID_MOBILE_NUMBER_FORMAT = 'Please enter a valid number';

// Driver licence
const INVALID_LICENCE_FORMAT = 'Please do not use any special characters, only alphanumeric values are allowed.';
const INVALID_LICENCE_FORMAT_NOMINATION = 'Only the following characters are allowed: letters, numbers and spaces';

// Residential address
const INVALID_ADDRESS_FORMAT = 'This field is required. No numeric or special characters are allowed.';
const EMPTY_ADDRESS = 'Please complete this field';

// Upload files
const INVALID_FILE_SIZE = 'Sorry, this file is either too large (must be less than 4MB) or it’s a file type we don’t accept. Accepted file types include: doc, docx, xls, xlsx, csv, jpeg, png, pdf, txt.';
const INVALID_FILE_TYPE = 'The type of file you are trying to attach is not accepted. The allowed types are: doc, docx, xls, xlsx, csv, jpeg, png, pdf, txt.';
const FILE_UPLOAD_FAIL = 'Sorry, your attachment has failed to upload. Please try again.';

// Preferred contact number/Fax number
const INVALID_PHONE_NUMBER = 'Please enter a valid contact number. No spaces or special characters are allowed.';
const INVALID_PHONE_NUMBER_LENGTH = 'Contact number must have a maximum of 10 numbers.';
const INVALID_PHONE_NUMBER_LENGTH_15 = 'Contact number must have a maximum of 15 numbers.';

const INVALID_OBLIGATION_NUMBER = 'Please enter a valid obligation number';
const FIELDS_WITH_SEPCIFI_CHARS_MSG = 'Please complete this field without the following characters: <>';
const INVALID_OBLIGATION_TOTAL_NUMBER = 'A maximum of 25 obligations can be accpected.';
const INVALID_OBLIGATION_NUMBER_DUPLICATE = 'Please complete this field without a duplicate obligation number.';

/* Special fields */
// Vehicle Registration
const INVALID_VEHICLE_REGISTRATION_NUMBER = 'Please enter a valid registration number, no lower cases, special characters are allowed.';

// Email
const INVALID_EMAIL = 'Please enter a valid email address.';

// Centrelink check
const MISSING_CENTRELINK_CHECK = 'You must agree to the statements above.';

// Declaration
const MISSING_DECLARATION_AGREEMENT = 'To submit, you will need to agree to the statements above.';

// Lodging Application
const MISSING_APPLICATION_LODGING_AGREEMENT = 'To continue, you must agree to the statement above.';

const INVALID_ORG_NAME_FORMAT = 'Please enter a valid name. Only the following characters are allowed - letters, numbers, space, @#\\()$%*&=-.,\'?!-:;"/|';

const INVALID_NAME_FORMAT_NO_SPECIAL = 'Please do not use any special characters.';

// i

const INVALID_OFFENCE_FIND_OUT_DATE = 'To be eligible, you must have found out about the fine within the past 14 days.';
const INVALID_ADDRESS_SEARCH_FORMAT = "Only the following characters are allowed: letters, numbers, spaces, and the following special characters :.;,'/\\()";
const INVALID_INPUT_LONGER_THAN_200_CHARS = 'Too Long. The input must be less than 200 characters';
const INVALID_INPUT_LONGER_THAN_100_CHARS = 'Too Long. The input must be less than 200 characters';
const INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION = 'Too Long. The input must be less than 100 characters';
const INVALID_INPUT_LONGER_THAN_80_CHARS = 'Too Long. The input must be less than 80 characters';
const INVALID_INPUT_LONGER_THAN_75_CHARS = 'Too Long. The input must be less than 75 characters';
const INVALID_INPUT_LONGER_THAN_50_CHARS = 'Too Long. The input must be less than 50 characters';
const INVALID_INPUT_LONGER_THAN_40_CHARS = 'Too Long. The input must be less than 40 characters';
const INVALID_INPUT_LONGER_THAN_25_CHARS = 'Too Long. The input must be less than 25 characters';
const INVALID_INPUT_LONGER_THAN_15_CHARS = 'Too Long. The input must be less than 15 characters';
const INVALID_INPUT_LONGER_THAN_10_CHARS = 'Too Long. The input must be less than 10 characters';
const INVALID_COMPANY_NAME = "Only the following characters are allowed: letters, numbers, spaces, and the following special characters @#\\()$%*&=-.,?!-:\"'/";
const INVALID_FREE_TEXT_FIELD_FORMAT = "Only the following characters are allowed: letters, numbers, spaces, and the following special characters $:%.;,\"@&?'#=!/\\_-()";
const INVALID_POSITION_IN_COMPANY_FIELD = "Only the following characters are allowed: letters, numbers, spaces, and the following special characters '-.,.";
const INVALID_VEHICLE_REGISTRATION_NUMBER_LENGTH = 'Please enter a valid registration number, no spaces or special characters are allowed.';
const INVALID_POST_CODE = 'Only the following characters are allowed: letters, numbers, spaces';
const INVALID_POST_CODE_NOMINATION = 'Only the following characters are allowed: letters, numbers and spaces';
const INVALID_ADDRESS_FIELD_ERROR = 'Only the following characters are allowed: letters, numbers, spaces, and the following special characters -:.;,\'/\\()&';

const INVALID_ABN = 'Please enter a valid ABN.';
const INVALID_ACN = 'Please enter a valid ACN.';
const INVALID_CRN = 'Invalid CRN. A CRN is 9 digits followed by a letter (eg. 123456789e).';
const INVALID_MIN_PAYMENT_FORTNIGHTLY = 'The minimum payment amount per fortnight is $10.';
const INVALID_MIN_PAYMENT_LOW = 'The minimum payment amount is $10 per fortnight or $20 per month';

const INVALID_MIN_PAYMENT_HIGH = 'The amount you have entered does not require a payment arrangement. You should pay your outstanding amount to avoid added costs';

function INVALID_REPAYMENT_TIME_LENGTH(minFortnightlyPayment: string, minMonthlyPayment: string): string {
    return `Repayment must be made within 10 years. Your repayment must be at least $${minFortnightlyPayment} per fortnight or $${minMonthlyPayment} per month`;
  }

function INVALID_FIRST_INSTALMENT_DATE(dateAfter28Days: Date): string {
  return `The date must be in the future and before ${dateAfter28Days.getDate()}/${dateAfter28Days.getMonth() + 1}/${dateAfter28Days.getFullYear()}`;
}

function INVALID_FILE_SIZE_CUSTOM(maxFileSize: string): string {
  return `Sorry, this file is either too large (must be less than ${maxFileSize}MB) or it’s a file type we don’t accept. Accepted file types include: doc, docx, xls, xlsx, csv, jpeg, png, pdf, txt.`;
}

const INVALID_MONETARY_AMOUNT = 'Please enter a valid amount';
const INVALID_NUMBER_INPUT = 'Please enter a valid number';
const CONFIRM_AUTHORISED = 'Please confirm that you are authorised.';

const CLICK_PLUS_ICON = "Please click the '+' icon to add the obligation or infringement number to this application";

export {
  INVALID_DAY,
  INVALID_DAY_LENGTH,
  INVALID_DAY_FORMAT,
  INVALID_MONTH,
  INVALID_MONTH_LENGTH,
  INVALID_MONTH_FORMAT,
  INVALID_YEAR,
  INVALID_YEAR_LENGTH,
  INVALID_YEAR_FORMAT,
  EMPTY_DATE,
  EMPTY_CHECKBOX,
  INVALID_DATE_INPUT_FORMAT,
  INVALID_FUTURE_DATE,
  INVALID_PAST_DATE,
  INVALID_NUMERIC_FORMAT,
  INVALID_YESNO_FORMAT,
  INVALID_NAME_FORMAT,
  INVALID_NAME_FORMAT_NEW,
  INVALID_ADDRESS_FORMAT,
  EMPTY_ADDRESS,
  INVALID_PHONE_NUMBER,
  INVALID_PHONE_NUMBER_LENGTH,
  INVALID_PHONE_NUMBER_LENGTH_15,
  INVALID_OBLIGATION_NUMBER,
  INVALID_OBLIGATION_TOTAL_NUMBER,
  INVALID_OBLIGATION_NUMBER_DUPLICATE,
  FIELDS_WITH_SEPCIFI_CHARS_MSG,
  INVALID_VEHICLE_REGISTRATION_NUMBER,
  INVALID_EMAIL,
  MISSING_CENTRELINK_CHECK,
  MISSING_DECLARATION_AGREEMENT,
  MISSING_APPLICATION_LODGING_AGREEMENT,
  INVALID_FILE_SIZE,
  INVALID_FILE_TYPE,
  FILE_UPLOAD_FAIL,
  INVALID_LICENCE_FORMAT,
  INVALID_LICENCE_FORMAT_NOMINATION,
  INVALID_MOBILE_NUMBER_FORMAT,
  INVALID_ORG_NAME_FORMAT,
  INVALID_NAME_FORMAT_NO_SPECIAL,
  INVALID_OFFENCE_FIND_OUT_DATE,
  INVALID_ADDRESS_SEARCH_FORMAT,
  INVALID_INPUT_LONGER_THAN_200_CHARS,
  INVALID_INPUT_LONGER_THAN_100_CHARS,
  INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION,
  INVALID_INPUT_LONGER_THAN_80_CHARS,
  INVALID_INPUT_LONGER_THAN_75_CHARS,
  INVALID_INPUT_LONGER_THAN_50_CHARS,
  INVALID_INPUT_LONGER_THAN_25_CHARS,
  INVALID_INPUT_LONGER_THAN_15_CHARS,
  INVALID_INPUT_LONGER_THAN_10_CHARS,
  INVALID_COMPANY_NAME,
  INVALID_FREE_TEXT_FIELD_FORMAT,
  INVALID_POSITION_IN_COMPANY_FIELD,
  INVALID_VEHICLE_REGISTRATION_NUMBER_LENGTH,
  INVALID_POST_CODE,
  INVALID_POST_CODE_NOMINATION,
  INVALID_ADDRESS_FIELD_ERROR,
  INVALID_ABN,
  INVALID_ACN,
  // INVALID_FILE_SIZE_CUSTOM,
  INVALID_INPUT_LONGER_THAN_40_CHARS,
  INVALID_CRN,
  INVALID_MIN_PAYMENT_FORTNIGHTLY,
  INVALID_MONETARY_AMOUNT,
  INVALID_MIN_PAYMENT_LOW,
  INVALID_MIN_PAYMENT_HIGH,
  INVALID_NUMBER_INPUT,
  INVALID_REPAYMENT_TIME_LENGTH,
  INVALID_FIRST_INSTALMENT_DATE,
  CONFIRM_AUTHORISED,
  INVALID_FILE_SIZE_CUSTOM,
  CLICK_PLUS_ICON
};
